import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { BandejaAutorizacionPage } from "@/features/bandeja-autorizacion/components/BandejaAutorizacionPage";
import {
  BANDEJA_PAGE_SIZE,
  bandejaAutorizacionQueryOptions,
} from "@/features/bandeja-autorizacion/hooks/use-bandeja-autorizacion";

/**
 * Ruta `/autorizacion/bandeja` · listado de pendientes para Autorizador
 * y MesaDeControl. Polling 5s dentro del queryOptions.
 *
 * El loader precarga la MISMA queryKey que arma la página al montar
 * (sin filtros · página 1) para que el primer render no re-fetchee.
 */
export const Route = createFileRoute("/_authed-tw/autorizacion/bandeja")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(
      bandejaAutorizacionQueryOptions({ page: 1, pageSize: BANDEJA_PAGE_SIZE }),
    ),
  component: () => (
    <PermissionGate permisos={[PERMISOS.autorizacionAutorizar]}>
      <BandejaAutorizacionPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
